import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AppBarWide, AppFlyoutHeightMaxWidth320, AppFlyoutMaxHeight, AppFlyoutMinHeight, AppFlyoutNoFooterHeight, AppFlyoutSmallMaxHeight, AppFlyoutSmallMinHeight, AppFlyoutWidth, AppFlyoutWidthMaxWidth320, TileDimensionDefault, TileHeightWide, } from './Constants';
export var useFlyoutButtonStyles = makeStyles({
    moreAppsButton: __assign(__assign({}, shorthands.borderWidth(0)), { minWidth: TileDimensionDefault, height: TileDimensionDefault, width: TileDimensionDefault, boxShadow: 'none', backgroundColor: tokens.colorSubtleBackground, fontWeight: tokens.fontWeightRegular, ':focus-visible': {
            outlineWidth: '2px',
            outlineStyle: 'solid',
            outlineColor: tokens.colorStrokeFocus2,
            outlineOffset: '-2px',
            boxShadow: 'none',
        }, ':hover': {
            backgroundColor: tokens.colorNeutralBackground4Selected,
            boxShadow: 'none',
        }, userSelect: 'none' }),
    moreAppsButtonContainer: {
        position: 'relative',
    },
    moreAppsButtonSelected: {
        backgroundColor: tokens.colorNeutralBackground4Selected,
    },
    wideMoreAppsButton: __assign({ minWidth: AppBarWide, width: AppBarWide, height: TileHeightWide }, shorthands.borderRadius(0)),
    flyoutContainer: __assign(__assign({ width: AppFlyoutWidth, maxHeight: AppFlyoutMaxHeight, minHeight: AppFlyoutMinHeight, boxShadow: tokens.shadow64, backgroundColor: tokens.colorNeutralBackground1 }, shorthands.padding(0)), { '@media (max-width: 320px)': {
            minHeight: AppFlyoutHeightMaxWidth320,
            maxHeight: AppFlyoutHeightMaxWidth320,
            width: AppFlyoutWidthMaxWidth320,
        } }),
    flyoutContainerNoFooter: {
        maxHeight: AppFlyoutNoFooterHeight,
        minHeight: AppFlyoutSmallMinHeight,
        paddingBottom: '20px',
        '@media (max-width: 320px)': {
            minHeight: AppFlyoutHeightMaxWidth320,
            maxHeight: AppFlyoutHeightMaxWidth320,
            width: AppFlyoutWidthMaxWidth320,
        },
    },
    flyoutContainerSmall: {
        maxHeight: AppFlyoutSmallMaxHeight,
        minHeight: AppFlyoutSmallMinHeight,
        height: 'auto',
    },
});
//# sourceMappingURL=FlyoutButton.styles.js.map